import A from './types';
import getStorageValue from '~/misc/getStorageValue';

const init = () => ({
  id: getStorageValue('installationId'),
  isAssigned: getStorageValue('installationIsAssigned'),
});

const reducer = (state, action) => {
  if (action.error || action.pending) {
    return null;
  }
  switch (action.type) {
    case A.INSTALLATION_CREATED:
      return {
        id: action.payload.id,
      };
    case A.INSTALLATION_USER_UPDATED:
      return {
        isAssigned: true,
      };
    case A.INSTALLATION_REMOVED:
      return {
        id: null,
        isAssigned: null,
      };
  }
  return null;
};

export default {reducer, init};



// WEBPACK FOOTER //
// ./src/modules/installation/reducer.js